import Landing from '@/pages/Landing'
import SignIn from '@/pages/SignIn'
import Welcome from '@/pages/Welcome'
import Palettes from '@/pages/Palettes'
import Profile from '@/pages/Profile'
//import Expired from "@/pages/Expired";
import Palette from "@/pages/Palette"
import Help from "@/pages/Help"
import InstalFf from "@/pages/InstallFf"
import Privacy from "@/pages/Privacy"
import Tos from "@/pages/Tos"
import NotFound from "@/pages/NotFound"
import Comparison from "@/pages/Comparison"
import ColorPalette from "@/pages/ColorPalette"
import ExtractPalette from "@/pages/ExtractPalette"
import WebsitePalette from "@/pages/WebsitePalette"
import SuccessStories from "@/pages/SuccessStories"
import { getSuccessStoryBySlug } from '@/data/successStories'
import store from '@/store/index.js';
import { createRouter, createWebHistory } from 'vue-router'
import { extensionId } from '../utils/constants';
import { updateCanonical, updateRobotsMeta } from '@/utils/useHeadUtils';

const routes = [
  {
    path: "/",
    name: 'homepage',
    component: Landing,
  },
  {
    path: "/sign-in",
    name: 'sign-in',
    component: SignIn,
    meta: { noindex: true },
  },
  {
    path: "/welcome",
    component: Welcome,
    meta: { noindex: true },
  },
  {
    path: "/palettes",
    component: Palettes,
    meta: { noindex: true },
  },
  {
    path: "/profile",
    name: 'profile',
    component: Profile,
    meta: { noindex: true },
  },
  {
    path: "/install-ff",
    name: 'install-ff',
    component: InstalFf,
  },
  /*{
    path: "/expired",
    name: 'expired',
    component: Expired,
  },*/
  {
    path: "/palette",
    name: 'palette',
    component: Palette,
    meta: { noindex: true },
  },
  {
    path: "/help",
    name: 'help',
    component: Help,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
  },
  {
    path: '/tos',
    name: 'tos',
    component: Tos,
  },
  {
    path: '/not-found',
    name: 'not-found',
    component: NotFound,
    meta: { noindex: true },
  },
  {
    path: '/comparison',
    name: 'comparison',
    component: Comparison
  },
  {
    path: '/vs-color',
    name: 'vs-color',
    component: ColorPalette
  },
  {
    path: '/vs-extract',
    name: 'vs-extract',
    component: ExtractPalette
  },
  {
    path: '/vs-website',
    name: 'vs-website',
    component: WebsitePalette
  },
  {
    path: '/success-stories',
    name: 'success-stories',
    component: SuccessStories,
  },
  {
    path: '/success-stories/:slug',
    name: 'success-story',
    component: () => import('@/pages/SuccessStory.vue'),
    beforeEnter: (to) => (getSuccessStoryBySlug(to.params.slug) ? true : '/not-found'),
    props: (route) => {
      const story = getSuccessStoryBySlug(route.params.slug);
      return story ? { story } : {};
    },
  },
  {
    path: '/:catchAll(.*)',
    component: NotFound,
    beforeEnter: (to) => {
      // Redirect blog post slugs from root to /blog/ path
      // Blog posts follow the pattern /YYYY-MM-DD-slug
      if (/^\/\d{4}-\d{2}-\d{2}/.test(to.path)) {
        const slug = to.path.replace(/\/$/, '');
        window.location.href = `/blog${slug}/`;
        return false;
      }
      return '/not-found';
    }
  },
];

const router = createRouter({
	routes,
	history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
      }
    }
    return { left: 0, top: 0 }
  }
})

router.beforeEach(async (to, from) => {
  if (to.query.ref && typeof to.query.ref === 'string') {
    const refValue = to.query.ref;
    
    if (refValue.includes('blog/')) {
      const cleanRef = refValue.replace(/\/blog\/.*$/, '')
                              .replace(/blog\/.*$/, '');
      
      if (cleanRef !== refValue) {
        const query = { ...to.query, ref: cleanRef || undefined };
        return { path: to.path, query };
      }
    }
  }

  // profitwell
  if(store.state.user && typeof window.profitwell === 'function')
    window.profitwell('start', { 'user_email': store.state.user.email});

  const utilsPages = ['help', 'privacy', 'tos', 'install-ff'];
  const comparisonPages = ['comparison', 'vs-color', 'vs-extract', 'vs-website']
  const marketingPages = ['success-stories', 'success-story']

  const arrayUnAuthPages =['sign-in', 'homepage', 'palette', ...utilsPages, ...comparisonPages, ...marketingPages];
  if ((!arrayUnAuthPages.includes(to.name) && !store.state.userToken)){
    router.push({ path: '/sign-in' });
  }
  if (to.name === 'sign-in' && store.state.userToken) {
    router.push({ path: '/profile' });
    if (typeof chrome === "undefined" || !chrome.runtime) {
      localStorage.setItem('palette.site_login', store.state.userToken);
      window.postMessage("externally_connectable.login")
    } else if (chrome.runtime) {
      chrome.runtime.sendMessage(extensionId, {
        command: "palette.site_login",
        token: store.state.userToken
      });
    }
    // router.push({ path: '/profile' });
  }
})
router.afterEach((to) => {
  const path = to.path === '/' ? '/' : to.path.replace(/\/$/, '');
  updateCanonical(`https://palette.site${path}`);

  if (to.meta.noindex) {
    updateRobotsMeta('noindex, nofollow');
  } else {
    updateRobotsMeta(null);
  }
});

export default router
